import { createClient } from '@/shared/api/client'
import { TargetSystem } from '@/shared/constants'
import { buildUrl } from '@/shared/utils/urls'

const client = createClient(buildUrl(TargetSystem.AssetManagement))

export async function attachReconFile(assetCode: string, uploadId: string) {
  await client.sendPut(`asset/${assetCode}/files/${uploadId}`)
}
